import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthComponent, AuthComponentState } from '../../components/auth/auth.component';
import { ModalHeaderComponent } from '../components/modal-header/modal-header.component';
import { Modal } from '../modal';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-auth-modal',
  standalone: true,
  imports: [
    CommonModule,
    ModalHeaderComponent, AuthComponent, TranslateModule
  ],
  templateUrl: './auth-modal.component.html',
  styleUrls: ['./auth-modal.component.scss']
})
export class AuthModalComponent extends Modal implements OnInit {

  @Input() title: string | undefined;
  @Input() state: AuthComponentState | undefined;
  @Input() initEmail: string | undefined;
  @Input() setRedirectAfterLoad: boolean | undefined;

  @Output() signedIn = new EventEmitter<boolean>();

  constructor() {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
    
  }

  onSignedIn(b: boolean) {
    this.signedIn.emit(b);
    if (b) this.close();
  }
}
